var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluetooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11732 0.0761497C6.49099 -0.0786313 6.92111 0.00692445 7.20711 0.292922L12.7071 5.79292C13.0976 6.18345 13.0976 6.81661 12.7071 7.20714L7.91421 12L12.7071 16.7929C13.0976 17.1834 13.0976 17.8166 12.7071 18.2071L7.20711 23.7071C6.92111 23.9931 6.49099 24.0787 6.11732 23.9239C5.74364 23.7691 5.5 23.4045 5.5 23V14.4142L1.70711 18.2071C1.31658 18.5977 0.683417 18.5977 0.292893 18.2071C-0.0976311 17.8166 -0.0976311 17.1834 0.292893 16.7929L5.08579 12L0.292893 7.20714C-0.0976311 6.81661 -0.0976311 6.18345 0.292893 5.79292C0.683417 5.4024 1.31658 5.4024 1.70711 5.79292L5.5 9.58582V1.00003C5.5 0.595567 5.74364 0.230931 6.11732 0.0761497ZM7.5 14.4142L10.5858 17.5L7.5 20.5858V14.4142ZM7.5 9.58582V3.41424L10.5858 6.50003L7.5 9.58582Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9592,
    y: 16.9403,
    width: 2,
    height: 11.2951,
    rx: 1,
    transform: "rotate(-135 15.9592 16.9403)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.946,
    y: 15.5261,
    width: 2,
    height: 11.2951,
    rx: 1,
    transform: "rotate(135 23.946 15.5261)",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/bluetooth.86296014b5ab1fb38e716d7efbf7c038.svg";
export { ForwardRef as ReactComponent };